import { Alert } from '@designsforhealth/dfh-react-components'
import React, { FC } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import styled from 'styled-components'

import { usePractitionerSettingsEager } from '../../../../lib/practitioner-settings/hooks/usePractitionerSettingsEager'
import Spacer from '../../../Spacer'
import Spinner from '../../../Spinner'
import AccountDocumentsSection from './practitioner/AccountDocumentsSection'
import OtherDocumentsSection from './practitioner/OtherDocumentsSection'

interface AccountDocumentsFieldValues {
  taxpayerIdForm: string
  taxExemptionForm: string
}

const Container = styled.div`
  @media (min-width: 768px) {
    max-width: 97%; //450px;
    h3 {
      max-width: 400px;
    }
  }
`

const AccountDocumentsContainer: FC = () => {
  const methods = useForm<AccountDocumentsFieldValues>()
  const {
    data: settings,
    loading: settingsLoading,
    error: settingsError,
  } = usePractitionerSettingsEager()

  if (settingsLoading) {
    return <Spinner loading />
  }

  if (settingsError || !settings) {
    console.error('Error loading practitioner settings', settingsError)
    return (
      <Alert type="error">
        We were unable to load your practitioner settings, please try again soon.
      </Alert>
    )
  }

  return (
    <Container>
      <FormProvider {...methods}>
        <AccountDocumentsSection settings={settings} />
        <Spacer size={5} />
        <OtherDocumentsSection settings={settings} />
        <Spacer size={5} />
      </FormProvider>
    </Container>
  )
}

export default AccountDocumentsContainer
